import HisVideo from "@/components/HisVideo";
import RealVideo from "@/components/RealVideo";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "real",
      component: RealVideo,
      meta: {
        noCache: false
      }
    },
    {
      path: "/his",
      name: "his",
      component: HisVideo,
      meta: {
        noCache: true
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js